import { render } from "./Subform.vue?vue&type=template&id=00c73b14&scoped=true"
import script from "./Subform.vue?vue&type=script&lang=js"
export * from "./Subform.vue?vue&type=script&lang=js"

import "./Subform.vue?vue&type=style&index=0&id=00c73b14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c73b14"]])

export default __exports__